import type { FC, ReactNode } from "react";
import { useIntl } from "@/infra/locale";
import type { CopyKeyCare } from "@akina/infra";
import { Checkbox, Text } from "@akina/presentation";

type LegalAcceptanceCheckboxRowProps = {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  onErrorClear?: () => void;
  labelMessageId: CopyKeyCare;
  children: ReactNode;
};

export const LegalAcceptanceCheckboxRow: FC<LegalAcceptanceCheckboxRowProps> = ({
  checked,
  onCheckedChange,
  onErrorClear,
  labelMessageId,
  children,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div className="mt-2 flex cursor-pointer flex-row">
      <div className="mr-3">
        <Checkbox
          checked={checked}
          onCheckedChange={() => {
            onCheckedChange(!checked);
            onErrorClear?.();
          }}
        />
      </div>
      <div className="flex flex-wrap gap-1">
        <button
          type="button"
          onClick={() => {
            onCheckedChange(!checked);
            onErrorClear?.();
          }}
          className="cursor-pointer border-0 bg-transparent p-0">
          <Text color={"text-gray-800/50"} size="base" className="whitespace-nowrap">
            {formatMessage({ id: labelMessageId })}
          </Text>
        </button>
        {children}
      </div>
    </div>
  );
};
